<template lang='pug'>
    r-table(
        :no-actions='!$can("VIEW_DETAIL_PREVISION_INDICATOR")'
        no-remove
        no-search
        ref='table'
        remind-key='prevision-indicator-list'
        v-bind='tableProps'
        @detail='submitDetail'
    )
</template>

<script>
    //
    import { mapActions, mapState } from 'vuex'
    import { RTable } from '@/components/reusable_components/next'
    //
    import HrIndicatorModel from '@/models/HumanResource/HrIndicator'
    //
    import HrIndicatorFilters from '@/views/HumanResource/HrPrevisionIndicator/HrIndicatorFilters'
    import HrIndicatorHeaders from '@/views/HumanResource/HrPrevisionIndicator/HrIndicatorHeaders'
    //
    export default {
        name: 'indicator-list',
        components: {
            RTable,
        },
        computed: {

            /**
             * 
             */
            tableProps() {
                return {
                    filters: HrIndicatorFilters,
                    mapperFilter: this.mapFilter,
                    headers: HrIndicatorHeaders,
                    service: HrIndicatorModel,
                }
            }
        },
        methods: {
            
            /**
             * 
             */
            ...mapActions('MenuesModule', [
                'setItemsTopBar',
                'setTitleTopBar',
            ]),

            mapFilter(filters) {

                //
                const period       = filters.period
                const period_month = period ? filters.period.split('-').pop() : undefined
                const period_year  = period ? filters.period.split('-').shift() : undefined

                //
                return {
                    period_month,
                    period_year,
                }
            },

            /**
             * 
             */
            submitCreate() {
                this.$router.push({ name: 'prevision-indicator-create' })
            },

            /**
             *
             */
            submitDetail(event) {
                this.$router.push({ name: 'prevision-indicator-update', params: { id: event.item.id } })
            },

        },
        beforeRouteEnter(to, from, next) {
            next(ctx => {
                if (!ctx.$can('VIEW_ALL_PREVISION_INDICATOR')) ctx.$router.push('/')
            })
        },
        mounted() {
            this.setTitleTopBar('Indicadores previsionales')
            this.setItemsTopBar([
                {
                    text: 'crear indicadores previsionales',
                    icon: 'add_circle',
                    action: this.submitCreate,
                },
            ])
        },
    }
</script>
